// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import base from './assets/base'
import GlobalVariable from './assets/globalVariable'
import BaiduMap from 'vue-baidu-map';
import request from "../src/assets/request";
import store from "@/vuex/store"
import 'babel-polyfill';
import Lodop from '@/utils/LodopFuncs'
import "./assets/css/main.scss";
import VueClipboard from 'vue-clipboard2'
// import '@/utils/push.js';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)


Vue.use(Lodop)
Vue.use(VueClipboard)
Vue.use(BaiduMap, {
    ak: 'IKCGrDVtxdNXTGGePRdYLo45ZBUlKNTm'
});
Vue.use(base);
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
    // Vue.prototype.$http = axios;
Vue.prototype.url = "https://api.yichengshi.cn/"
    // Vue.prototype.url ="http://192.168.1.103:8084/"
    // Vue.prototype.url = "http://192.168.1.18:8084"
Vue.prototype.request = request
Vue.prototype.shopList = '123'
Vue.prototype.Global = GlobalVariable
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    axios,
    router,
    store,
    render: h => h(App),
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js